import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
	state: {
		title: 'Welcome to Kasasa',
		headline: 'Welcome to Kasasa',
		modalText: '',
		showModal: false,
		showWell: true,
		hasSubtitle: false,
		subtitle: '',
		hasError: false,
		errorText: '',
		hideConsumerLogin: false,
		showLoader: false,
	},
	getters: {
		title: (state) => state.title,
		headline: (state) => state.headline,
		modalText: (state) => state.modalText,
		showModal: (state) => state.showModal,
		showWell: (state) => state.showWell,
		hasSubtitle: (state) => state.hasSubtitle,
		subtitle: (state) => state.subtitle,
		hasError: (state) => state.hasError,
		errorText: (state) => state.errorText,
		hideConsumerLogin: (state) => state.hideConsumerLogin,
		showLoader: (state) => state.showLoader,
	},
	mutations: {
		setTitle(state, newTitle) {
			state.title = newTitle;
		},
		setHeadline(state, newHeadline) {
			state.headline = newHeadline;
		},
		setModalText(state, newError) {
			state.modalText = newError;
		},
		toggleModal(state) {
			state.showModal = !state.showModal;
		},
		setWellState(state, newState) {
			state.showWell = newState;
		},
		setHasSubtitleState(state, newState) {
			state.hasSubtitle = newState;
		},
		setSubtitle(state, newSubtitle) {
			state.subtitle = newSubtitle;
		},
		setHasErrorState(state, newState) {
			state.hasError = newState;
		},
		setErrorText(state, text) {
			state.errorText = text;
		},
		setConsumerLoginState(state, newState) {
			state.hideConsumerLogin = newState;
		},
		setLoaderState(state, newState) {
			state.showLoader = newState;
		},
	},
	actions: {
		updateTitle: ({ commit }, newTitle) => {
			commit('setTitle', newTitle);
			window.document.title = newTitle;
		},
		showError({ commit }, text) {
			commit('setErrorText', text);
			commit('setHasErrorState', true);
		},
		clearError({ commit }) {
			commit('setErrorText', '');
			commit('setHasErrorState', false);
		},
	},
	modules: {},
});

export default store;
